import * as actionTypes from "../../constants/actionTypes";
import { getBalance, getAccount } from "../../common/BPADBlockStakeContract";
import {
  checkIfLogin,
  setLocalStorageForLogout,
} from "../../common/helpers/helper";
import { reqAccountAndSignature } from "../../common/BPADBlockStakeContract";

import {
  setLoading,
  setAccountDetails,
  setError,
  hideWalletModal,
} from "./globalActions";

import Messages from "../../constants/messages";
const { LOGIN_MESSAGE } = Messages;

const setLogin = (isLogin, token, msg) => ({
  type: actionTypes.UPDATE_LOGIN,
  payload: {
    isLogin,
    token,
    msg,
  },
});

export const setRequestStatus = (requestStatus) => ({
  type: actionTypes.SET_REQUEST_STATUS,
  payload: {
    requestStatus,
  },
});

export const setLoginLoading = (loading) => ({
  type: actionTypes.SET_LOGIN_LOADING,
  payload: { loading },
});

export const login = (account, signature, msg, walletType) => {
  return async (dispatch, getState) => {
    // setTimeout(() => {
    if (true) {
      localStorage.setItem("token", JSON.stringify("asdfasfdasdf"));
      localStorage.setItem("id", JSON.stringify("asdfasfdasdf"));
      localStorage.setItem("walletType", JSON.stringify("METAMASK"));
      dispatch(setLogin(true, "asdfasfdasdf", msg));
      getBalance(account).then((res) => {
        console.log("currentChainId", res)
        dispatch(setAccountDetails(account, signature, res));
      });
    }
    dispatch(setLoginLoading(false));
    dispatch(setRequestStatus(false));
    console.log("debug: ", "wow reached")
    dispatch(hideWalletModal());
    // }, 2000);
  };
};

export const logout = (_, history) => {
  return async (dispatch, getState) => {
    const isLogin = getState().login.isLogin;

    if (!isLogin) return;

    dispatch(setLoading(true));

    setTimeout(() => {
      setLocalStorageForLogout();
      dispatch(setAccountDetails("", "", 0));
      dispatch(setLogin(false, ""));
    }, 500);
  };
};

export const getSignInMsg = (walletType) => {
  return async (dispatch) => {
    try {
      const message = "Please sign the below message";
      const [account, signature] = await reqAccountAndSignature(message);
      console.log("debug: ", account, signature)
      dispatch(setLoginLoading(false));
      dispatch(setRequestStatus(true));
      // setTimeout(() => {
      dispatch(login(account, signature, message, walletType));
      // }, 2000);
    } catch (error) {
      console.log("debug: ", error)
      dispatch(setLoginLoading(false));
      dispatch(setRequestStatus(false));
      if (error?.code?.toString() === "4001") {
        dispatch(
          setError(error, {
            errorTitle: "Signature rejected",
            errorMsg: LOGIN_MESSAGE.invalidSignature.message,
            errorBtnLabel: "Retry",
          })
        );
      }
    }
  };
};

export const checkIfLoginAndUpdateState = (callback) => {
  return async (dispatch) => {
    const token = JSON.parse(localStorage.getItem("token"));
    try {
      const account = await getAccount();
      if (checkIfLogin() && account) {
        getBalance(account).then((res) =>
          dispatch(setAccountDetails(account, "", res))
        );
        dispatch(setLogin(true, token, ""));
      }
    } catch (error) {
      setLocalStorageForLogout();
    } finally {
      callback(false);
    }
  };
};
